import * as _ from "lodash";
import { call, put, select } from "redux-saga/effects";

import actions from "@/actions";

import handleDuplicateFlags from "./handle-duplicate-flags/handle-duplicate-flags";

/**
 * Assigns the selected BLE beacon to the current light and re-runs duplicate detection.
 *
 * @param root0 - The action.
 * @param root0.payload - The BLE beacon selection data.
 * @yields Selects light data, dispatches BLE assignment, and runs duplicate detection.
 */
function* selectBLE({ payload }) {
    try {
        const { lights, selectedLight } = yield select(({ map }) => ({
            lights: _.cloneDeep(map.values.global.present.lights),
            selectedLight: map.general.selectedLights[0],
        }));
        const light = lights[selectedLight];
        yield put(
            actions.window.openLoading(
                "Hold on! We're marking all duplicates...",
            ),
        );
        light.bleId = payload.beaconID;
        light.bleUUID = payload.BLEBeaconUUId;
        light.id = payload.vlcId;
        yield call(handleDuplicateFlags, lights);
        yield put(actions.map.general.setFloorspaceCatalogs([]));
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log("err on checking floorspace catalog:", err);
    } finally {
        yield put(actions.window.closeLoading());
    }
}

export default selectBLE;
